export default "__VITE_ASSET__ChfD3RVE__"